import {QueryResultType} from 'graphql-client/BenchlingQuery';

/** Empty-state text shown in a schema dropdown while its schemas are still loading. */
export const LOADING_SCHEMAS_PLACEHOLDER = 'Loading available schemas...';

/**
 * Maps a schema query's state to the empty-state text a schema dropdown should show while no schema is
 * selected. Returns the loading text only while PENDING; every other state (including ERROR) returns
 * `undefined` so the dropdown keeps its default 'Select a schema...'. Error rendering is intentionally
 * left to the dropdown's existing error handling.
 *
 * Callers should only invoke this where the true query state is known (i.e. at a querying hook), so that a
 * settled query is never mislabeled as loading.
 */
export function getSchemaSelectorPlaceholder(state: QueryResultType): string | undefined {
  if (state === QueryResultType.PENDING) {
    return LOADING_SCHEMAS_PLACEHOLDER;
  }
  return undefined;
}
